import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import get from 'lodash/get';
import { BREAKPOINTS, getAddress } from '../../utils/commonHelper';
import { contactPropTypes } from '../../utils/commonPropTypes';
import { getSellerName, isFSBOContact } from '../../utils/listingHelper';

import {
  addLead,
  trackPhoneCall,
  trackPhoneNumberReveal
} from '../../store/actions/dataLayer';
import './styles.css';
import { getMessages } from '../../tppServices/translations/messages';

class SellerInformation extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      callText: '',
      classNameDesktop: 'seller-tel-anchor-desktop',
      clickEvent: this.handleRevealNumber,
      href: '#',
      isClickable: true
    };
  }

  handlePhoneCall = () => {
    this.props.trackPhoneCall();
    this.props.addLead(this.props.listingId, 'phone lead');
    if (window.kruxCall) {
      window.kruxCall();
    }
  };

  handleRevealNumber = (e) => {
    this.setPhoneCallState();
    this.props.trackPhoneNumberReveal();
    this.props.addLead(this.props.listingId, 'phone lead');
    this.props.trackPhoneCall();
    if (window.kruxCall) {
      window.kruxCall();
    }
    e.stopPropagation();
  };

  setPhoneCallState = () => {
    this.setState(() => ({
      callText: get(this.props, 'contact.phone'),
      clickEvent: this.handlePhoneCall,
      href: `tel:${get(this.props, 'contact.phone')}`,
      isClickable: true
    }));
  };

  componentDidMount() {
    if (this.props.revealDealerPhoneNumber) {
      this.setPhoneCallState();
    }
  }

  render() {
    const {
      breakpoint,
      contact,
      name,
      revealDealerPhoneNumber,
      intl: { formatMessage: t }
    } = this.props;
    const messages = getMessages();

    let sellerName = getSellerName(contact, name);
    const address = get(contact, 'address', {});

    const callSellerNow = t(messages.contactGroup.callSellerNow, {
      sellerName
    });

    const callNowOrPhone =
      this.state.callText ||
      (breakpoint === BREAKPOINTS.desktop
        ? t(messages.contactGroup.phoneReveal)
        : t(messages.contactGroup.call));

    let phoneDesktopElement;
    if (!revealDealerPhoneNumber) {
      phoneDesktopElement = (
        <p className="seller-tel-paragraph">{get(contact, 'phone')}</p>
      );
    }

    const isFSBOPrivate = isFSBOContact(contact);

    return (
      <div className="seller-information">
        <p className="seller-info-name">{sellerName}</p>
        {this.props.isModal && <br />}
        {!isFSBOPrivate && (
          <>
            <div className="seller-info-location">
              <address>
                <a
                  className="seller-address"
                  href={`https://maps.google.com/?q=${encodeURIComponent(
                    getAddress(address)
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Seller adress"
                >
                  {getAddress(address)}
                </a>
              </address>
            </div>
            <div className="seller-info-tel">
              <a
                className="seller-tel-anchor"
                href={this.state.href}
                title={callSellerNow}
                onClick={(e) => this.state.clickEvent(e)}
              >
                {callNowOrPhone}
              </a>
              {phoneDesktopElement}
            </div>
          </>
        )}
      </div>
    );
  }
}

SellerInformation.propTypes = {
  addLead: PropTypes.func.isRequired,
  /** Current screen size breakpoint */
  breakpoint: PropTypes.oneOf(Object.keys(BREAKPOINTS)),
  contact: contactPropTypes.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }).isRequired,
  listingId: PropTypes.number,
  name: PropTypes.string,
  trackPhoneCall: PropTypes.func.isRequired,
  trackPhoneNumberReveal: PropTypes.func.isRequired,
  revealDealerPhoneNumber: PropTypes.bool,
  isModal: PropTypes.bool
};

export default connect(null, (dispatch) =>
  bindActionCreators(
    {
      addLead,
      trackPhoneCall,
      trackPhoneNumberReveal
    },
    dispatch
  )
)(injectIntl(SellerInformation));
